import { Attributes, LookupBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class LinkedInvestorLookup extends LookupBase {

    public investorID: number = 0;

    @Attributes.Integer()
    public investorTypeID: number = 0;

    public firstName: string = "";

    public surname: string = "";
}